export default () => ({
  dropDownIconSection: {
    fill: '#000000',
  },
  ExpansionPaneldropDownIcon: {
    left: '-98%',
  },
  expansionPanelDetailsRoot: {
    display: 'block',
  },
});
